let namespace = 'derWareHouseInRd_';

const initialState = {
    pagination: {
        pageSize: 5,
        current: 1,
        showSizeChanger: true,
        showQuickJumper:true,
        pageSizeOptions: [
            "5",
            "10",
            "20",
            "40",
            "100"
        ]
    },
    dataFetchProps: {
        order: [['id', 'desc']],
        attributes: ["id", "serial_no", "pur_order", "pur_contract", "enter_total_weight", "order_no", "apply_no", "remarks","goods_control_mode", "confirm_list", "goods_info_list", "confirm_time", "warehouse_enterprise_no", "warehouse_name", "cust_name", "pay_time", "status"],
        include: [
            {
                model: "der_warehouse_file", // 替换为实际的 Model 名称
                as: 'm_derWareHouseFile',
                attributes: ['id', 'local_url', 'status', 'attachment_type', 'bank_url']
            }
        ]
    },
    deleteType:'发送',
    colorType:'primary',
    uploadModalVisible: false,
    // 搜索参数
    searchProps: {},
    // 加载状态，默认是true
    loading: false,
    newLoading: false,
    // 数据列表
    dataList: [],
    // 详细信息显示
    orderRepayDetailVisible: false,
    orderDetailVisible: false,
    // 正在被查看的项（详细）
    watchedItem: {},
}

export default function (state = initialState, action) {
    switch (action.type) {
        case namespace + "forcedUpdate": {
            return {
                ...state,
                ...action.payload
            }
        };
        default : {
            return state;
        }
    }
}